import { Route, Routes } from "react-router-dom"


import Cotizador from "./Cotizador"
import ListarPagos from "./ListarPagos"


const VentasRoutes = () => (
    <Routes>
        <Route path="/" Component={Cotizador} />
        <Route path="/Pagos/:idUsuario" Component={ListarPagos} />
    </Routes>
)

export default VentasRoutes